module.exports = __webpack_public_path__ + "static/media/slide1.7990e07e.png";